import { createSelector } from 'reselect';

import NAMESPACE from './types';

function _metaSelector(state) {
    return state[NAMESPACE].meta;
}

function _dataSelector(state) {
    return state[NAMESPACE].data;
}

function _errorSelector(state) {
    return state[NAMESPACE].error;
}

function _fetchingSelector(meta) {
    return meta.fetching;
}

function _userLocationSelector(data) {
    return data.ping.ipLocation;
}

function _capabilitiesSelector(data) {
    return data?.ping?.capabilities;
}

function _userAgentSelector(data) {
    return data.userAgent;
}

function _browserLanguageSelector(data) {
    if (data.ping.suggestion) {
        return data.ping.suggestion.language.toLowerCase();
    }

    return null;
}

function _browserCurrencySelector(data) {
    if (data.ping.suggestion) {
        return data.ping.suggestion.currency;
    }

    return null;
}

const selectBrowserMetaFetching = createSelector(
    _metaSelector,
    _fetchingSelector,
);

const selectBrowserMetaError = createSelector(
    _errorSelector,
    (error) => error,
);

const selectUserAgent = createSelector(
    _dataSelector,
    _userAgentSelector,
);

const selectUserLocation = createSelector(
    _dataSelector,
    _userLocationSelector,
);

const selectBrowserCurrency = createSelector(
    _dataSelector,
    _browserCurrencySelector,
);

const selectBrowserLanguage = createSelector(
    _dataSelector,
    _browserLanguageSelector,
);

const selectFeatureCapabilities = createSelector(
    _dataSelector,
    _capabilitiesSelector,
);

export {
    selectBrowserCurrency,
    selectBrowserLanguage,
    selectBrowserMetaError,
    selectBrowserMetaFetching,
    selectFeatureCapabilities,
    selectUserAgent,
    selectUserLocation,
};
